import {
  cssClass,
  Style,
  vizPortalFontStyle
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { Messages } from '../../../../gen-src/Localize';

const rootStyle: Style = {
  ...vizPortalFontStyle,
  flex: 1,
  position: 'relative',
  top: '15%', // same as vizportal client
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const rootClass = cssClass('UnrecognizedUrlRoot', rootStyle);

export type UnrecognizedUrlProps = {
  readonly backToButtonLabel: string;
  readonly backToButtonUrl: string;
};

export function UnrecognizedUrl(props: UnrecognizedUrlProps): JSX.Element {
  return (
    <div className={rootClass}>
      <div>{Messages.UnrecognizedUrl()}</div>
      <Link to={props.backToButtonUrl}>{props.backToButtonLabel}</Link>
    </div>
  );
}
